<template>
      <div class="ruleCertificationEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'ruleCertification', params: {} }">
          Rule Certification
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'ruleCertificationEdit', params:{id: id} }">
            Edit Rule Certification
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Rule Certification</v-card-title>
          <v-card-text>
            <ruleCertification-form :id="id"></ruleCertification-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import RuleCertificationForm from './RuleCertificationForm.vue';

    export default {
      name: 'ruleCertification',
      data () {
        return {
          id: null
        }
      },
      components: {
        RuleCertificationForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    